<app-pagetitle title="Configurações de Documentos" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    @if(!podeVer){
    <app-no-access></app-no-access>
    }@else{
    <div class="col-lg-4">

        <app-card-settings title="Categorias de Orçamento"
            message="Defina quais categorias são apresentadas em documentos que usam o orçamento."
            titleButton="Configurar"
            url="/telemarketing/projetos/configuracoes/parametros-orcamento"></app-card-settings>
    </div>
    <div class="col-lg-4">

        <app-card-settings title="Itens de Orçamento"
            message="Cadastre, atualize e exclua itens, produtos e mão de obra para o orçamento."
            titleButton="Configurar" url="/telemarketing/projetos/itens-orcamento"></app-card-settings>
    </div>
    <div class="col-lg-4">

        <app-card-settings title="Template de Documentos"
            message="Configure o Layout padrão dos documentos (Contrato, Orçamento, Porposta Comercial, etc)."
            titleButton="Configurar" url="/telemarketing/projetos/configuracoes/templates"></app-card-settings>
    </div>
    }
</div>